module.exports = __webpack_public_path__ + "img/logo-fkbv.08e13db7.png";